module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('div', {
    staticClass: "display-flex mb-5"
  }, [_c('div', {
    staticClass: "volver display-flex flex-1"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.volver()
      }
    }
  }, [_vm._m(0), _c('span', [_vm._v("Volver")])])])]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-cajas",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "contenedor-glosa mb-0"
  }, [_c('h4', {
    staticClass: "titulo"
  }, [_c('strong', [_vm._v(_vm._s(_vm.titulo))])]), _c('br'), _c('h3', {
    staticClass: "organizador"
  }, [_vm._v("Organizador: " + _vm._s(_vm.nombreCreador))]), _c('h3', {
    staticClass: "fecha"
  }, [_vm._v("Cuando:  " + _vm._s(_vm.fecha) + " " + _vm._s(_vm.horaDesde && _vm.horaHasta ? (_vm.horaDesde + " - " + _vm.horaHasta) : ''))]), _c('br')]), _c('div', {
    staticClass: "contenedor-glosa flex cuerpo"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('p', {
    staticClass: "pt-10 descripcion mb-5",
    domProps: {
      "innerHTML": _vm._s(_vm.convertirSaltosDeLinea(_vm.descripcion))
    }
  }), (_vm.salaTitulo) ? _c('section', [_c('h1', {
    staticClass: "tipo"
  }, [_vm._v("Lugar")]), _c('h3', {
    staticClass: "titulo"
  }, [_vm._v("Sala: " + _vm._s(_vm.salaTitulo))]), (_vm.salaDescripcion) ? [_c('p', {
    staticClass: "pt-10 descripcion",
    domProps: {
      "innerHTML": _vm._s(_vm.convertirSaltosDeLinea(_vm.salaDescripcion))
    }
  })] : _vm._e()], 2) : _vm._e(), (_vm.link) ? _c('section', {
    staticClass: "contenedor-glosa"
  }, [_c('a', {
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_vm._v("Ingresar a " + _vm._s(_vm.tipo === 'reunion' ? 'la reunión' : 'la capacitación'))])]) : _vm._e()]), _c('div', {
    staticClass: "asistentes"
  }, [_c('h1', {
    staticClass: "tipo mb-10"
  }, [_vm._v("Asistentes")]), _c('div', {
    staticClass: "lista overflow-y-scroll"
  }, _vm._l((_vm.asistentes), function(o, index) {
    return _c('div', {
      staticClass: "asistente-item"
    }, [_c('h3', {
      staticClass: "nombre"
    }, [_vm._v(_vm._s(o.nombre || o.nombreExterno))]), _c('span', {
      staticClass: "cargo"
    }, [_vm._v(_vm._s(o.cargo || o.cargoExterno))]), (o.externo) ? _c('span', {
      staticClass: "externo-span"
    }, [_vm._v("  (Externo)")]) : _vm._e()])
  }), 0)])]), (_vm.estado === 0 && _vm.codigoCreador !== _vm.codigo) ? [_c('button', {
    staticClass: "button is-small is-success mr-5",
    on: {
      "click": function($event) {
        return _vm.marcarAsitencia(1)
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-up is-small"
  })]), _c('span', [_vm._v("Asistí")])]), _c('button', {
    staticClass: "button is-small is-danger",
    on: {
      "click": function($event) {
        return _vm.marcarAsitencia(0)
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-down is-small"
  })]), _c('span', [_vm._v("No asistí")])])] : _vm._e(), (_vm.asistio !== null && _vm.fechaMarcaAsistio) ? _c('h2', [_vm._v("Marcó " + _vm._s(_vm.asistio ? 'sí' : 'no') + " asistió : " + _vm._s(_vm.fechaMarcaAsistio))]) : _vm._e(), (_vm.minutaLink || _vm.minutaDescripcion) ? _c('div', {
    staticClass: "contenedor-glosa"
  }, [_c('h1', {
    staticClass: "tipo"
  }, [_vm._v("Minuta")]), (_vm.minutaDescripcion) ? _c('p', {
    staticClass: "pt-10 descripcion",
    domProps: {
      "innerHTML": _vm._s(_vm.convertirSaltosDeLinea(_vm.minutaDescripcion))
    }
  }) : _vm._e(), (_vm.minutaLink) ? _c('a', {
    attrs: {
      "href": _vm.minutaLink,
      "target": "_blank"
    }
  }, [_vm._v("Ver minuta")]) : _vm._e()]) : _vm._e()], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b10f4334","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_Reunion_Vista_Detallada.vue
// module id = 943
// module chunks = 0